class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');
    document.body.classList.add("overflow-hidden")
    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.classList.remove("overflow-hidden")
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      // The popup is intentionally not opened. Instead of swapping the whole
      // cart icon markup (which would replace the header's "Cart" label with
      // the legacy icon+bubble), we only update the numeric count in place and
      // bump the count element so just the number circle animates.
      const count = this.getCartCount(parsedState);
      if (count != null) {
        this.updateCartCount(count);
      } else {
        // Fallback for forms that don't request the cart-icon-bubble section.
        const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
        fetch(`${cartUrl}.js`)
          .then((r) => r.json())
          .then((cart) => this.updateCartCount(cart.item_count))
          .catch(() => {});
      }

      if (this.header) this.header.reveal();
      this.announceAdded();
  }

  getCartCount(parsedState) {
    // Read the authoritative count from the freshly rendered cart-icon-bubble
    // section returned with the add response.
    const html = parsedState && parsedState.sections && parsedState.sections['cart-icon-bubble'];
    if (html) {
      const numEl = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector('.cart-count-bubble [aria-hidden="true"]');
      if (numEl) {
        const n = parseInt(numEl.textContent.trim(), 10);
        if (!Number.isNaN(n)) return n;
      }
    }
    if (parsedState && typeof parsedState.item_count === 'number') return parsedState.item_count;
    return null;
  }

  updateCartCount(count) {
    if (count == null) return;

    ['cart-icon-bubble', 'cart-icon-bubble-mobile'].forEach((id) => {
      const wrap = document.getElementById(id);
      if (!wrap) return;

      // header-new uses a "Cart" label + .header-new__cart-count pill.
      // Legacy header / mobile use a .cart-count-bubble circle.
      const isHeaderNew = !!wrap.querySelector('.header-new__cart-label');
      let el = wrap.querySelector('.header-new__cart-count, .cart-count-bubble');

      if (count > 0) {
        if (!el) {
          el = document.createElement(isHeaderNew ? 'span' : 'div');
          el.className = isHeaderNew ? 'header-new__cart-count' : 'cart-count-bubble';
          wrap.appendChild(el);
        }
        const visible = count < 100 ? `${count < 10 ? '0' : ''}${count}` : '';
        el.innerHTML = `<span aria-hidden="true">${visible}</span><span class="visually-hidden">${count} items</span>`;
        // Force reflow so the spring animation re-plays on every add.
        el.classList.remove('bump');
        void el.offsetWidth;
        el.classList.add('bump');
      } else if (el) {
        el.remove();
      }
    });
  }

  announceAdded() {
    let liveRegion = document.getElementById('cart-live-region');
    if (!liveRegion) {
      liveRegion = document.createElement('div');
      liveRegion.id = 'cart-live-region';
      liveRegion.className = 'visually-hidden';
      liveRegion.setAttribute('aria-live', 'polite');
      liveRegion.setAttribute('role', 'status');
      document.body.appendChild(liveRegion);
    }
    const heading = this.notification.querySelector('.cart-notification__heading');
    liveRegion.textContent = heading ? heading.textContent.trim() : 'Item added to your cart';
  }

  getSectionsToRender() {
    // Only the cart icon bubble is needed now that the popup is disabled.
    // `section` mirrors `id` so forms that map either property keep working.
    return [
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && target.closest('.cart-notification-background')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
